{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-9-franzoesisch-imparfait-futur-objektpronomen",
  "version": "2026.08.1",
  "title": "Französisch 9 IIIa: Grammatik – Imparfait vs. Passé composé, Futur und Objektpronomen (Realschule 9 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Französisch 9 (Wahlpflichtfächergruppe IIIa): Imparfait (Bildung, Verwendung vs. Passé composé), Futur simple, direkte und indirekte Objektpronomen (me, te, le, la, lui, leur) und Pronomenstellung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:15:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/9/franzoesisch",
      "checked": "2026-08-15",
      "label": "Realschule Französisch 9 (Wahlpflichtfächergruppe IIIa), Lernbereiche Sprachliche Mittel und Grammatik"
    }
  ],
  "atoms": [
    {
      "id": "01K4F9M0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4F9M0000000000000000A01",
      "namespace": "franzoesisch-grammatik",
      "slug": "imparfait-bildung-verwendung-vs-passe-compose",
      "title": "Das Imparfait: Bildung (nous-Stamm + Endungen) und Abgrenzung zum Passé composé (Zustand vs. Handlung)",
      "domain": "schule/franzoesisch/grammatik",
      "reduction": "formal",
      "typical_age_min": 14.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q150",
          "target_label": "Imparfait",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "IIIa",
          "subject": "franzoesisch",
          "topic_code": "lb1",
          "topic_title": "Grammatik und Vergangenheitszeiten",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4F9M0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Aus welchem Stamm werden die regelmäßigen Formen des Imparfait im Französischen für alle Verben abgeleitet?",
          "concept": "Aus dem Stamm der 1. Person Plural (nous-Form) im Présent durch Anhängen der Endungen -ais, -ais, -ait, -ions, -iez, -aient",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Aus dem Stamm der nous-Form im Présent",
              "Aus dem Infinitiv"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4F9M0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre Bildung und Kontrastierung der beiden französischen Vergangenheitszeiten: 1. **Bildung des Imparfait**: Stamm der *nous*-Form im Présent + feste Endungen: *-ais, -ais, -ait, -ions, -iez, -aient* (einzige Ausnahme: *être -> ét-* [*j'étais*]), 2. **Wann Imparfait?**: Für andauernde Zustände, Beschreibungen von Wetter/Personen/Landschaften, Gewohnheiten in der Vergangenheit (*tous les jours, souvent*), Hintergrundhandlungen (*pendant que...*), 3. **Wann Passé composé?**: Für einmalige, abgeschlossene Handlungen, Handlungsketten (*d'abord, puis, ensuite*) und neu eintretende, plötzliche Ereignisse (*tout à coup*), die die Hintergrundhandlung unterbrechen und übersetze: 'Als ich klein war [Zustand], spielte ich jeden Tag im Garten [Gewohnheit], aber gestern ging ich ins Kino [einmalige Handlung].'",
          "concept": "Imparfait: nous-Stamm + -ais/-ait/-ions/-iez/-aient; Zustand/Wetter/Gewohnheit/Hintergrund vs. Passé composé: punktuelle Handlungskette/plötzliches Ereignis; 'Quand j'étais petit, je jouais tous les jours dans le jardin, mais hier je suis allé au cinéma.'",
          "sample_solution": "1. Bildung des Imparfait: - **Regel**: Man nimmt die 1. Person Plural (*nous*-Form) des Verbs im Présent, streicht die Endung *-ons* ab und hängt die 6 unveränderlichen Imparfait-Endungen an:   * *je* $\\rightarrow$ **-ais**   * *tu* $\\rightarrow$ **-ais**   * *il / elle / on* $\\rightarrow$ **-ait**   * *nous* $\\rightarrow$ **-ions**   * *vous* $\\rightarrow$ **-iez**   * *ils / elles* $\\rightarrow$ **-aient** [stumm, klingt wie *-ais*]. - *Beispiel parler* (nous parlons): *je parlais, tu parlais, il parlait, nous parlions, vous parliez, ils parlaient*. - *Einzige Stamm-Ausnahme*: **être** $\\rightarrow$ Stamm **ét-** (*j'étais, tu étais, il était, nous étions, vous étiez, ils étaient*). 2. Der fundamentale Zeitenkontrast: Imparfait vs. Passé composé: - **1. Das Imparfait (Die 'Videokamera' / Der Hintergrund)**:   * **Beschreibungen**: Wie war das Wetter? Wie sahen Personen/Orte aus? Gefühlszustände (*'Il faisait beau, j'étais triste'*).   * **Regelmäßige Gewohnheiten**: Was geschah wiederholt? (*'Chaque été, nous allions à la mer'*).   * **Andauernde Hintergrundhandlungen**: Was lief gerade im Hintergrund ab? (*'Pendant que je dormais...'*). - **2. Das Passé composé (Der 'Fotoapparat' / Die Haupthandlung)**:   * **Punktuelle Einzelhandlungen**: Neu einsetzende Ereignisse mit festem Start/Ende (*'Hier, j'ai acheté un vélo'*).   * **Handlungsketten**: Nacheinander ablaufende Aktionen (*'D'abord il a mangé, puis il est parti'*).   * **Plötzliche Unterbrechung**: Mitten in die Hintergrundhandlung (*'Pendant que je lisais, le téléphone a sonné'*). 3. Übersetzung des Beispielsatzes: - *„Quand j'étais petit [Zustand/Imparfait], je jouais tous les jours dans le jardin [Gewohnheit/Imparfait], mais hier je suis allé au cinéma [einmalige Handlung/Passé composé].“*"
        }
      ]
    },
    {
      "id": "01K4F9M0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4F9M0000000000000000A02",
      "namespace": "franzoesisch-grammatik",
      "slug": "objektpronomen-direkt-indirekt-stellung-verneinung",
      "title": "Objektpronomen: Direkte (COD) vs. Indirekte Pronomen (COI) und Pronomenstellung vor dem Verb",
      "domain": "schule/franzoesisch/grammatik",
      "reduction": "formal",
      "typical_age_min": 14.5,
      "prerequisites": [
        {
          "atom_id": "01K4F9M0000000000000000A01",
          "type": "hard",
          "rationale": "Satzbau und Pronomenstrukturen bauen auf den Grundzeiten auf."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q150",
          "target_label": "French personal pronouns",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "IIIa",
          "subject": "franzoesisch",
          "topic_code": "lb1",
          "topic_title": "Grammatik und Sprachliche Mittel",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4F9M0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "An welcher Position stehen französische Objektpronomen (z. B. 'me, te, le, la, lui, leur') im bejahten und verneinten Aussagesatz?",
          "concept": "Direkt VOR dem konjugierten Verb (z. B. 'Je l'aime' / 'Je ne lui parle pas')",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Direkt VOR dem konjugierten Verb",
              "Hinter dem Verb wie im Deutschen"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4F9M0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Differenziere die beiden Klassen persönlicher Objektpronomen im Französischen: 1. **Direkte Objektpronomen (COD / Akkusativ: wen oder was?)**: *me, te, le / la / l', nous, vous, les* (ersetzen Nomen ohne Präposition, z. B. *'Je regarde le film' -> 'Je le regarde'*), 2. **Indirekte Objektpronomen (COI / Dativ: wem?)**: *me, te, lui (ihm/ihr), nous, vous, leur (ihnen)* (ersetzen Personen mit Präposition *à*, z. B. *'Je téléphone à Paul' -> 'Je lui téléphone'*), 3. **Stellung im Satz** (immer vor dem finiten Verb, bei Verneinung: *Subjekt + ne + Pronomen + Verb + pas*; bei 2 Verben wie *aller + Infinitiv* vor dem Infinitiv!) und übersetze: a) 'Ich sehe ihn.' b) 'Ich antworte ihr nicht.' c) 'Wir werden sie (die Freunde) einladen.'",
          "concept": "COD: me, te, le/la, nous, vous, les (direktes Objekt); COI: me, te, lui, nous, vous, leur (Dativobjekt nach à); Pronomenstellung: vor finitem Verb bzw. vor Infinitiv; a) 'Je le vois.' b) 'Je ne lui réponds pas.' c) 'Nous allons les inviter.'",
          "sample_solution": "1. Die beiden Systeme der französischen Objektpronomen: - **1. Direkte Objektpronomen (COD – Complément d'objet direct)**:   * Ersetzen ein direktes Nomen (Akkusativ: *Wen oder was?* ohne Präposition).   * Formen:     - *me / m'* (mich) | *nous* (uns)     - *te / t'* (dich) | *vous* (euch / Sie)     - **le / l'** (ihn / es - männlich) | **les** (sie - Plural)     - **la / l'** (sie / es - weiblich).   * *Beispiel*: *« Tu connais cette chanson ? – Oui, je **la** connais. »* - **2. Indirekte Objektpronomen (COI – Complément d'objet indirect)**:   * Ersetzen ein Nomen mit der Präposition **à** (Dativ: *Wem?*).   * Formen:     - *me / m'* (mir) | *nous* (uns)     - *te / t'* (dir) | *vous* (euch / Ihnen)     - **lui** (ihm **und** ihr! Kein Geschlechtsunterschied!)     - **leur** (ihnen - Plural).   * *Beispiel*: *« Tu parles à ta mère ? – Oui, je **lui** parle. »* 2. Die eiserne Regel der Pronomenstellung: - Objektpronomen stehen im Französischen **immer direkt vor dem Prädikat / Verb**:   * **Einfacher Aussagesatz**: $\\mathbf{\\text{Subjekt} + \\mathbf{Pronomen} + \\text{Verb}}$ (*'Je **le** vois'*).   * **Verneinter Satz**: $\\mathbf{\\text{Subjekt} + \\mathbf{ne} + \\mathbf{Pronomen} + \\text{Verb} + \\mathbf{pas}}$ (*'Je **ne lui** réponds **pas**'*).   * **Satz mit Hilfsverb / Infinitiv** (*aller + Infinitiv, vouloir + Infinitiv*): Das Pronomen wandert **direkt vor den Infinitiv** (*'Je vais **l\\'**inviter'*). 3. Übersetzungen: - a) 'Ich sehe ihn.' $\\rightarrow$ **« Je le vois. »** (COD *le* vor *vois*). - b) 'Ich antworte ihr nicht.' $\\rightarrow$ **« Je ne lui réponds pas. »** (COI *lui* für *à elle* eingeklammert von *ne ... pas*). - c) 'Wir werden sie (die Freunde) einladen.' $\\rightarrow$ **« Nous allons les inviter. »** (COD *les* steht direkt vor dem Infinitiv *inviter*)."
        }
      ]
    }
  ]
}
